import React, { Component } from 'react'

import './WhiteBoxTestAbCard.scss'

export default class WhiteBoxTestAbCard extends Component {
  render() {
    return (
      <div
        id="WhiteBoxTestAbCard"
        className={
          'WhiteBoxTestAbCard ' +
          (this.props.className ? this.props.className : '')
        }
      >
        {this.props.children ? this.props.children : ''}
      </div>
    )
  }
}
